import UserPermissionsForm from "../../components/userPermissionsForm";
import React, {useEffect, useState} from "react";
import Selector from "../../components/common/selector";
import {fetchDistricts, restoreCurrentDistrictFromLocalStorage} from "../../actions/districts";
import {
  clearSchools,
  clearSchoolsLists,
  fetchSchools,
  fetchSchoolsLists,
  schoolsListsRemove
} from "../../actions/schools";
import {useDispatch, useSelector} from "react-redux";
import { fetchPermissionsList, saveUserPermissions} from "../../actions/users";
import FormCheckbox from "../../components/common/formCheckbox";
import FormRadio from "../../components/common/formRadio";
import PermissionDistrictRow from "../../components/permissionDistrictRow";

const CreatePermissions = () => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const [permissionLevel, setPermissionLevel] = useState('');
  const [permissionType, setPermissionType] = useState('schools');
  const [permissionDistricts, setPermissionDistricts] = useState([]);
  const [permissionSchools, setPermissionSchools] = useState([]);
  const [sendInvite, setSendInvite] = useState(true);
  const [showPermissionType, setShowPermissionType] = useState(false);
  const [showDistricts, setShowDistricts] = useState(false);
  const [showSchools, setShowSchools] = useState(false);
  const [addRows, setAddRows] = useState(false);
  //This holds an array of keys for the permission rows
  const [permissionsRows, setPermissionsRows] = useState([0]);

  useEffect(() => {
    async function getAllDistrictsAndPermissionsList() {
      if (!districts) {
        await dispatch(fetchDistricts());
      }

      if (!permissionsList) {
        await dispatch(fetchPermissionsList());
      }
    }

    getAllDistrictsAndPermissionsList();
  });


  const districts = useSelector((state) => state.districts.districts);
  const permissionsList = useSelector((state) => state.users.permissionsList);
  const newUser = useSelector((state) => state.users.createdUser);

  const permissionLevelOnChange = async (newLevel) => {
    let submitDisabled = true;
    let showAddRows = addRows;

    setPermissionLevel(newLevel);
    switch (newLevel) {
      case 'ROLE_PERMISSION_SUPER_USER':
        showAddRows = false;
        submitDisabled = false;
        await dispatch(clearSchoolsLists());
        setShowDistricts(false);
        setShowSchools(false);
        setShowPermissionType(false);
        clearAllPermissionValues();
        break;
      case 'ROLE_PERMISSION_ADMIN':
        showAddRows = true;
        submitDisabled = true;
        setShowPermissionType(false);
        setShowSchools(false);
        setShowDistricts(true);
        clearSchoolValues();
        break;
      case 'ROLE_PERMISSION_COORDINATOR':
      case 'ROLE_PERMISSION_VIEWER':
        showAddRows = true;
        setShowPermissionType(false);
        if (showDistricts === false) {
          setShowDistricts(true);
        }
        if (permissionDistricts && permissionDistricts.length > 0) {
          setShowSchools(true);
        }
        break;
      case 'ROLE_PERMISSION_BATCH':
        showAddRows = true;

        setShowPermissionType(true);

        if (showDistricts === false) {
          setShowDistricts(true);
        }

        if (permissionDistricts && permissionType === 'schools') {
          setShowSchools(true);
        }
        break;
      default:
        showAddRows = false;
        submitDisabled = true;
        await dispatch(clearSchoolsLists());
        setShowDistricts(false);
        setShowSchools(false);
        setShowPermissionType(false);
        clearAllPermissionValues();
        break;
    }

    if (submitDisabled !== disabled) {
      setDisabled(submitDisabled);
    }

    setAddRows(showAddRows);
  }

  const permissionTypeOnChange = (permissionType) => {
    setPermissionType(permissionType);
    switch (permissionType) {
      case 'districts':
        setShowSchools(false);
        clearSchoolValues();
        break;
      case 'schools':
        setShowSchools(true);
        break;
      default:
    }
  }

  const districtChange = async (newDistrict, index) => {
    let newPermissionDistricts = permissionDistricts.slice();
    let submitDisabled = true;
    let districtObject = null;
    let clearSchools = false;

    if (districts) {
      districtObject = districts.find(element => element.id === parseInt(newDistrict));
    }

    if (parseInt(newDistrict) === 0) {
      setDisabled(true);
    } else {
      if (districtObject) {
        await dispatch(fetchSchoolsLists(districtObject, index));
      }

      switch (permissionLevel) {
        case 'ROLE_PERMISSION_ADMIN':
          submitDisabled = false;
          setShowSchools(false);
          break;
        case 'ROLE_PERMISSION_COORDINATOR':
        case 'ROLE_PERMISSION_VIEWER':
          if (districtObject) {
            setShowSchools(true);
            clearSchools = true;
          }
          break;
        case 'ROLE_PERMISSION_BATCH':
          if (districtObject) {
            if (permissionType === 'schools') {
              setShowSchools(true);
              clearSchools = true;
            } else {
              submitDisabled = false;
            }
          }
          break;
        default:
          break;
      }
      if (districtObject) {
        newPermissionDistricts[index] = districtObject;
        setPermissionDistricts(newPermissionDistricts);
      }

      if (clearSchools && permissionSchools[index]) {
        schoolChange([], index);
      }

      if (submitDisabled !== disabled) {
        setDisabled(submitDisabled);
      }
    }
  }

  const schoolsLists = useSelector((state) => state.schools.schoolsLists);

  const schoolChange = (selectedSchools, districtIndex) => {
    let newPermissionSchools = permissionSchools.slice();
    let schoolObject = null;

    let schoolsToSubmit = [];

    if (!newPermissionSchools[districtIndex]) {
      newPermissionSchools[districtIndex] = [];
    }

    selectedSchools.forEach((school) => {
      schoolObject = schoolsLists[districtIndex].find(element => element.id === school.value )

      if (schoolObject) {
        schoolsToSubmit.push(schoolObject);
      }
    })

    newPermissionSchools[districtIndex] = schoolsToSubmit;

    if (schoolsToSubmit.length > 0) {
      setDisabled(false);
    }

    setPermissionSchools(newPermissionSchools);
  };

  function clearAllPermissionValues() {
    clearDistrictValues();
    clearSchoolValues();
    clearPermissionRows();
  }

  function clearDistrictValues() {
    setPermissionDistricts([]);
  }

  function clearSchoolValues() {
    setPermissionSchools([]);
  }

  function clearPermissionRows() {
    setPermissionsRows([0]);
  }

  function getSchoolListFromPermissionSchools(permissionSchools) {
    return permissionSchools.flat();
  }

  const onSubmitAction = () => {
    setDisabled(true);
    const permissions = {
      'permissionLevel': permissionLevel
    }

    if (permissionLevel && permissionLevel !== 'ROLE_PERMISSION_SUPER_USER') {
      if (permissionLevel === 'ROLE_PERMISSION_ADMIN' || (permissionLevel === 'ROLE_PERMISSION_BATCH' && permissionType === 'districts')) {
        permissions.districts = permissionDistricts;
      } else {
        permissions.schools = getSchoolListFromPermissionSchools(permissionSchools);
      }
    }
    dispatch(saveUserPermissions(newUser, permissions, sendInvite));
  }

  const getSelectItems = (items, defaultLabel) => {
    const defaultItem = {id: 0, name: defaultLabel};

    if (!items) {
      return [defaultItem];
    }

    const selectItems = items;

    if (!selectItems.find((item) => item.id === 0)) {
      selectItems.unshift(defaultItem);
    }


    return selectItems;
  }

  function filterSelectedItems(items, selectedItems, index) {
    const selectItems = [];

    if (selectedItems.length === 0) {
      return items;
    }

    const currentSelectedItem = selectedItems[index];

    items.forEach((item) => {
      let showItem = true;

      if (currentSelectedItem && item.id !== currentSelectedItem.id) {
        selectedItems.forEach((selectedItem) => {
          if (item.id === selectedItem) {
            showItem = false;
          }
        });
      }

      if (showItem === true) {
        selectItems.push(item);
      }
    });

    return selectItems;
  }

  const addAction = () => {
    const newPermissionsRows = permissionsRows.slice();
    const permissionsMax = Math.max(...newPermissionsRows);
    newPermissionsRows.push(permissionsMax+1);
    setPermissionsRows(newPermissionsRows);
  }

  const removeAction = async (index) => {
    const newPermissionsRows = permissionsRows.slice();
    const newPermissionSchools = permissionSchools.slice();
    const newPermissionDistricts = permissionDistricts.slice();
    const rowToRemove = newPermissionsRows.indexOf(index);

    if (index > -1) {
      newPermissionsRows.splice(rowToRemove, 1);
      newPermissionDistricts.splice(rowToRemove, 1);
      newPermissionSchools.splice(rowToRemove, 1);

      await dispatch(schoolsListsRemove(index));
      await setPermissionDistricts(newPermissionDistricts);
      await setPermissionSchools(newPermissionSchools);
      await setPermissionsRows(Array.from(newPermissionsRows.keys()));
    }
  }

  function buildPermissionLevelList() {
    const permissionsLevelList = permissionsList.map((permission) =>  {
      if (permission.authority === 'ROLE_PERMISSION_USER') {
        return false;
      }

      return {
        label: permission.name,
        value: permission.authority
      }
    }).filter((permission) => permission !== false);

    permissionsLevelList.unshift({
      label: 'Select Permission Level',
      value: ''
    });

    return permissionsLevelList;
  }

  function getSelectedValues(schoolPermissions) {
    const schoolPermissionValues = [];
    schoolPermissions.forEach((schoolPermission) => {
      if (schoolPermission) {
        schoolPermissionValues.push(schoolPermission.id);
      }
    });

    return schoolPermissionValues;
  }

  const districtRow = (index) => {
    return <PermissionDistrictRow
      districtIndex={index}
      districts = {filterSelectedItems(getSelectItems(districts, 'Select a District'),
        permissionDistricts,
        index)}
      schools = {(schoolsLists !== []) ? schoolsLists[index] : []}
      districtChange={districtChange}
      schoolChange={schoolChange}
      removeAction={removeAction}
      permissionDistricts={permissionDistricts}
      permissionSchools={permissionSchools}
      showDistricts={showDistricts}
      showSchools={showSchools}
    />
  }

  const permissionTypeValues = [
    {
      value: 'schools',
      label: 'Schools'
    },
    {
      value: 'districts',
      label: 'Districts'
    }
  ]

  let children = <>
    <Selector
      name="role"
      label='Permission Level'
      value={permissionLevel}
      changeAction={permissionLevelOnChange}
      showLabel={true}
      items={(permissionsList) ? buildPermissionLevelList(permissionsList) : []}
    />
    <FormRadio
      name='permission-type'
      label='Assign to'
      changeAction={permissionTypeOnChange}
      options={permissionTypeValues}
      disabled={!showPermissionType}
      hide={!showPermissionType}
      value={permissionType}
    />

    {permissionsRows.map((row) => {
      return districtRow(row);
    })}
  </>

  const sendInviteField = <FormCheckbox
    name='sendInvite'
    id='sendInvite'
    value={sendInvite}
    checked={!!sendInvite}
    label='Send Invite'
    changeAction={setSendInvite}
  />

  return (
    <UserPermissionsForm
      formTitle='User Permissions'
      hideTitle={true}
      submitAction={onSubmitAction}
      submitLabel='Submit'
      disabled={disabled}
      hideAddRow={!addRows}
      addAction={addAction}
      sendInviteField={sendInviteField}
    >
      {children}
    </UserPermissionsForm>
  );
}

export default CreatePermissions;